import { render } from "./AppGridXjh.vue?vue&type=template&id=3c1f4cad&scoped=true"
import script from "./AppGridXjh.vue?vue&type=script&lang=js"
export * from "./AppGridXjh.vue?vue&type=script&lang=js"

import "./AppGridXjh.vue?vue&type=style&index=0&id=3c1f4cad&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1f4cad"]])

export default __exports__